export default "__VITE_ASSET__qNPPG7xL__"